/**
 * SYR-105 — Auto-Concierge inside the CRM.
 *
 * Sits next to The Hypothesis for the same reason that one does: this is sales
 * work, not model configuration. A pack is outreach to an account, it sends
 * through the CRM sender, and it lands on that account's timeline. The AI Hub
 * page keeps what belongs to it, the prompts, the provider and the flags.
 */

import React from 'react';
import { AdminConciergePage } from '../../pages/AdminConciergePage';

export const CrmConciergeTab: React.FC = () => <AdminConciergePage embedded />;

export default CrmConciergeTab;
